import Cookies from 'universal-cookie';
import { API_VERSION, ENDPOINT } from './Service';

const cookies = new Cookies();

const buildHeaders = () => {
  let defaultLng = 'en';

  if (cookies.get('lng') && cookies.get('lng') !== undefined) {
    defaultLng = cookies.get('lng');
  }

  return {
    Accept: 'application/json',
    'Access-Control-Allow-Origin': '*',
    'X-Panda-Source': 'PandaClick',
    'X-Language': defaultLng,
    'X-PandaClick-Agent': 1,
    'api-version': API_VERSION,
    'Content-Type': 'application/json'
  };
};

export const fetchScreenRestrictionConfigs = async () => {
  const response = await fetch(`${ENDPOINT}/configs?group=screen_restriction`, {
    method: 'GET',
    headers: buildHeaders()
  });

  const json = await response.json();
  const rawConfigs = json?.data?.configs;

  if (Array.isArray(rawConfigs)) return rawConfigs;
  if (Array.isArray(rawConfigs?.screen_restriction)) return rawConfigs.screen_restriction;

  return [];
};

export const getScreenRestriction = async (screen) => {
  try {
    const restrictions = await fetchScreenRestrictionConfigs();

    if (!Array.isArray(restrictions) || restrictions.length === 0) {
      return null;
    }

    return (
      restrictions.find(
        (restriction) => restriction?.screen === screen && restriction?.restriction_enable === true
      ) ?? null
    );
  } catch (error) {
    console.error('Error fetching screen restrictions:', error);
    return null;
  }
};
